export const INSTAGRAM_LINK = 'https://instagram.com/elandic.tv';
export const VIMEO_LINK = 'https://vimeo.com/elandic';
